import { Box, Typography } from '@mui/material';
import { AiOutlinePlayCircle } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import BasicModal from './Modal';

import whatsappImg from 'assets/whatsapp_incoming.svg';
import { setShowLiveChat } from 'store/reducer/customerReducer';
import { useAppDispatch } from 'hooks/useRedux';

interface ModalProps {
  customerId: string;
  open: boolean;
  onClose: () => void;
}

const IncomingMessageModal = ({ customerId, open, onClose }: ModalProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  return (
    <BasicModal
      open={open}
      onClose={onClose}
      children={
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: '1.2rem',
              fontWeight: 600,
              maxWidth: '75%',
              textAlign: 'center',
              lineHeight: 1.3,
            }}
          >
            There is an incoming message from the customer
          </Typography>
          <Typography
            sx={{
              margin: '10px 0 2rem',
            }}
          >
            Click Accept to attend the chat
          </Typography>

          <Box>
            <img src={whatsappImg} alt='' />
          </Box>

          <button>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                color: '#fff',
                backgroundColor: '#6AC5AB',
                padding: '14px 2.5rem',
                borderRadius: '80px',
                margin: '1rem',
              }}
              onClick={() => {
                navigate(`/customer-details/${customerId}`);
                dispatch(setShowLiveChat(true));
                onClose();
              }}
            >
              <AiOutlinePlayCircle size={24} />
              <Typography mt='2px'>Join Chat</Typography>
            </Box>
          </button>

          <Typography
            sx={{
              color: '#0069AA',
              fontSize: '0.9rem',
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
          >
            Skip and pass it to other agent
          </Typography>
        </Box>
      }
    />
  );
};

export default IncomingMessageModal;
